/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".forget-bg[_ngcontent-%COMP%]{background-color:rgba(0,21,41,1);min-height:100vh}.forget-logo[_ngcontent-%COMP%]{margin-bottom:10px;padding-top:100px}.forget-copyright[_ngcontent-%COMP%]{text-align:center;padding-bottom:1rem}.forget-copyright[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px}span[_ngcontent-%COMP%]{color:#fff}\n/*# sourceMappingURL=forget.component.css.map*/"];
export { styles as styles };
